import { useEffect, useState } from 'react';

export function useScrollState() {
  const [isScroll, setScroll] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleScroll = () => setScroll(window.scrollY > 1);
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return isScroll;
}
